'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var List = function List(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, otherProps),
    _react2.default.createElement('line', {
      x1: '8',
      y1: '6',
      x2: '21',
      y2: '6',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '8',
      y1: '12',
      x2: '21',
      y2: '12',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '8',
      y1: '18',
      x2: '21',
      y2: '18',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '3',
      y1: '6',
      x2: '3',
      y2: '6',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '3',
      y1: '12',
      x2: '3',
      y2: '12',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '3',
      y1: '18',
      x2: '3',
      y2: '18',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeMiterlimit: '10',
      strokeWidth: '2'
    })
  );
};

List.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

List.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./~/react-feather/dist/icons/list.js
// module id = ./node_modules/react-feather/dist/icons/list.js
// module chunks = 168707334958949